package ir.hosen.resume.screen

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.invert
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import ir.hosen.resume.pages.Theme
import ir.hosen.resume.styles.InterestStyle
import ir.hosen.resume.util.Res
import ir.hosen.resume.util.bps
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.Img

@Composable
fun ExperiencePartThreeScreen(modifier: Modifier = Modifier) {
    Box(
        modifier = modifier,
        contentAlignment = Alignment.Center
    ) {
        Content(modifier = modifier.width(60.vw))
    }
}

@Composable
private fun Content(modifier: Modifier = Modifier) {
    val interestImages = remember {
        (1..12).toList().map { "/interest_$it.jpeg" }
    }
    Column(
        modifier = modifier,
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(32.px)
    ) {
        Row(verticalAlignment = Alignment.Top) {
            SpanText(
                modifier = Modifier.color(Theme.onBackgroundColor).fontFamily(Res.String.ROBOTO_CONDENSED)
                    .fontSize(32.bps()),
                text = "Sometimes I love to click."
            )
            Img(
                src = "/portal_star.svg",
                attrs = Modifier.size(22.px).filter(invert(if (Theme.isDark) 0 else 1)).toAttrs()
            )
        }

        SimpleGrid(
            numColumns = numColumns(base = 1, sm = 6), modifier = Modifier.gap(16.px).padding(24.px)
        ) {
            interestImages.forEach {
                InterestCard(
                    modifier = InterestStyle.toModifier().transition(Transition.of("transform", 1.s)),
                    src = it
                )
            }
        }
    }

}

@Composable
private fun InterestCard(modifier: Modifier = Modifier, src: String) {
    Box(
        modifier = modifier.size(width = 157.px, height = 209.px).padding(8.px).borderRadius(10.px),
        contentAlignment = Alignment.Center
    ) {
        Image(
            modifier = Modifier.fillMaxSize().objectFit(ObjectFit.Cover).borderRadius(10.px),
            src = src,
        )
    }
}